/* =============================================================================
   Celnovix — 商品页统一行为脚本（全局唯一实现，不再依赖 templates/*.json 里的"自定义 Liquid"区块）

   为什么要放在这里：
     之前这些逻辑写在每个商品模板的 custom-liquid 区块里。模板数据（templates/*.json）会在
     主题编辑器保存、主题上传时被整体重写，区块可能丢失（线上实测：rhodiola 页面两个区块消失，
     同一个 section 里的第三个还在）。放进 assets/ 代码文件后：
       · 所有现有商品 + 以后新建商品的模板，一律自动生效（无需逐模板加区块）
       · 编辑器保存、主题上传都不会动它（代码文件不是模板数据）
       · 全站只有一处实现，不会出现"有的页面有、有的页面没有"

   两个模块：
     1) 数量 ↔ 价格联动：一次性行 / 订阅行 / 顶部 ADD TO CART 按钮价格随数量与购买方式变化。
        采用"唯一写入者"机制（摘掉主题的写入标记类），因此不会出现中间错误值、不闪烁。
     2) selling_plan 保险：提交前把空值 / 0 / null / 未知计划 id 归一为空串（fail-open），
        避免编辑器预览里残留非法值时 Shopify 回 422「The product '…' is already sold out.」。
        只改 value，不删 DOM 元素（比旧实现更安全）。
   （"每瓶价 / Bottle" 不在本脚本内：已有套餐卡片的模板，卡片上本来就印了 $x / Bottle，
     且那些模板没有独立价格区；主题自带的数量档更新价格功能也已在工作。）   ============================================================================= */
(function () {
  'use strict';

  if (window.__celnovixProductLoaded) return;
  window.__celnovixProductLoaded = 1;

  var done = {};

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function moneyFormat() {
    var el = document.querySelector('[data-money-format]');
    var fmt = el ? el.getAttribute('data-money-format') : '';
    return fmt || '${{amount}}';
  }

  function money(cents, fmt) {
    try {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, fmt || moneyFormat(), false);
      }
    } catch (e) { /* 主题格式化函数不可用时退回简单格式 */ }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------------------------------------------------------------------
     1) 数量 ↔ 价格联动（唯一写入者，无闪烁）
     --------------------------------------------------------------------------- */
  function initLinkage() {
    var w = document.querySelector('.subscription-widget');
    if (!w || !w.dataset) return false;                 /* 组件还没渲染 → 等重试 */
    var sec = w.dataset.section;
    if (!sec) return false;
    if (document.getElementById('quantity-breaks-' + sec)) return true;  /* 有套餐卡片 → 卡片逻辑优先，本脚本不插手 */

    var fmt = w.dataset.moneyFormat || moneyFormat();
    var rows = qsa('.subscription__price', w);
    var otEl = w.querySelector('.subscription__price.one-time-price-update') ||
               w.querySelector('.subscription__price.one-time-price') || rows[0] || null;
    var spEl = w.querySelector('.subscription__price.sub-price-update') || rows[1] || null;

    /* 摘掉主题的写入标记类（这两个类只被脚本使用、CSS 不引用）→ 主题不再写入中间错误值 */
    [otEl, spEl].forEach(function (el) {
      if (!el) return;
      el.classList.remove('sub-price-update');
      el.classList.remove('one-time-price-update');
      el.style.visibility = '';
    });

    var busy = false;

    function qty() {
      var box = document.getElementById('Quantity-Form-' + sec);
      var inp = (box && box.querySelector('.quantity__input')) || document.querySelector('input[name="quantity"]');
      var v = inp ? parseInt(inp.value, 10) : 1;
      return (isNaN(v) || v < 1) ? 1 : v;
    }

    function mode() {
      var s = w.querySelector('.subscription__box--selected');
      return (s && s.dataset && s.dataset.type) || 'one_time';
    }

    function planUnit() {
      var p = w.querySelector('input[data-price]:checked') || w.querySelector('.subscription__frequency-input');
      var v = (p && p.dataset) ? parseInt(p.dataset.price, 10) : NaN;
      return isNaN(v) ? null : v;
    }

    function render() {
      if (busy) return;
      busy = true;
      try {
        var q = qty();
        var base = parseInt(w.dataset.basePrice || '0', 10);
        if (!base) return;
        var pu = planUnit();
        var wantOt = money(base * q, fmt);
        var wantSp = pu ? money(pu * q, fmt) : null;
        if (otEl && otEl.textContent.trim() !== wantOt) otEl.textContent = wantOt;
        if (spEl && wantSp && spEl.textContent.trim() !== wantSp) spEl.textContent = wantSp;
        /* 顶部 ADD TO CART 按钮：每次实时查找（它可能在脚本之后才渲染，也可能有多个实例） */
        var amt = ((mode() === 'subscription' && pu) ? pu : base) * q;
        var wantBtn = money(amt, fmt);
        qsa('.main-atc-price-span-' + sec).forEach(function (el) {
          if (el.textContent.trim() !== wantBtn) el.textContent = wantBtn;
        });
      } finally {
        busy = false;
      }
    }

    function schedule() {
      render();
      if (window.queueMicrotask) queueMicrotask(render);
      if (window.requestAnimationFrame) requestAnimationFrame(render);
    }

    ['pointerdown', 'mousedown', 'touchstart', 'click', 'change', 'input', 'keyup', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, schedule, true);
    });

    try {
      new MutationObserver(render).observe(w, { subtree: true, childList: true, characterData: true });
    } catch (e) { /* 老浏览器忽略 */ }

    render();
    [400, 900, 1800, 3000].forEach(function (t) { setTimeout(render, t); });
    return true;
  }

  /* ---------------------------------------------------------------------------
     2) selling_plan 保险（fail-open）
     --------------------------------------------------------------------------- */
  function planIdSet() {
    var out = [];
    qsa('input[name="selling_plan"], input[name="selling_plan_id"], [data-selling-plan-id]').forEach(function (el) {
      var v = String(el.value || el.getAttribute('data-selling-plan-id') || '').trim();
      if (v && out.indexOf(v) === -1) out.push(v);
    });
    return out;
  }

  function cleanForm(form, valid) {
    if (!form || !form.querySelectorAll) return;
    var list = valid.length ? valid : planIdSet();
    qsa('input[name="selling_plan"], input[name="selling_plan_id"]', form).forEach(function (i) {
      var v = String(i.value || '').trim();
      var junk = (v === '' || v === '0' || v === 'null' || v === 'undefined' || v === 'NaN');
      if (junk || (list.length && list.indexOf(v) === -1)) i.value = '';
    });
  }

  function initGuard() {
    var valid = planIdSet();
    document.addEventListener('submit', function (e) { cleanForm(e.target, valid); }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      var b = (t && t.closest) ? t.closest('button[type="submit"], input[type="submit"]') : null;
      if (b && b.form) cleanForm(b.form, valid);
      qsa('form[action*="/cart/add"]').forEach(function (f) { cleanForm(f, valid); });
    }, true);
    return true;
  }

  /* ---------------------------------------------------------------------------
     启动（幂等；订阅组件由自定义元素延迟升级，故多次兜底重试）
     --------------------------------------------------------------------------- */
  function boot() {
    if (!done.guard) { done.guard = initGuard(); }
    if (!done.link) { done.link = initLinkage(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  [600, 1500, 3000, 5000].forEach(function (t) { setTimeout(boot, t); });
})();
